export const getHostDomain = () => {
  if (window.parent !== window) {
    // remove the http:// prefix as well as the last '/' charcter
    const url = document.referrer.replace(/(^\w+:|^)\/\//, '');
    const [domain] = url.split('/');
    return domain;
  }

  return window.location.host;
};
